import svg11 from "../../assets/svg/svg11.svg";
import svg12 from "../../assets/svg/svg12.svg";
import svg13 from "../../assets/svg/svg13.svg";
import svg14 from "../../assets/svg/svg14.svg";

function Numbers() {
  const stats = [
    {
      id: 1,
      icon: svg11,
      label: "Speed",
      value: "3s Avg",
      description:
        "Processing time for median end-to-end processing across major rails.",
    },
    {
      id: 2,
      icon: svg12,
      label: "Scale",
      value: "100M+",
      description: "Monthly volume, moving funds for fast-growing businesses.",
    },
    {
      id: 3,
      icon: svg13,
      label: "Reach",
      value: "500K+",
      description:
        "Active users including merchants and consumers across Africa.",
    },
    {
      id: 4,
      icon: svg14,
      label: "Reliability",
      value: "99.99%",
      description: "Uptime with redundant infrastructure monitoring 24/7.",
    },
  ];

  return (
    <>
      <div className="flex items-center flex-col justify-center">
        <div className="flex items-center text-ndovuRed">
          <span className="w-[1.25rem] h-[0.09375rem]"></span>
          <span className="text-[1rem] font-[500] leading-[1.625rem] uppercase">
            Our numbers
          </span>
        </div>

        <div className="mt-[1rem] text-[#000] text-[1.75rem] md:text-[2.25rem] font-[500] leading-[2.625rem] max-w-full lg:max-w-[34rem] w-full text-center px-4">
          Performance at scale, built for commerce
        </div>
      </div>

      <div className="mt-[3.5rem] grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[1.5rem] lg:gap-[2.62rem]">
        {stats &&
          stats?.map((item) => (
            <div key={item.id} className="min-h-[17.1875rem] h-auto rounded-[1.25rem] bg-white numbers-card px-[1.5rem] md:px-[2rem] py-[2.5rem] border border-[#FBFBFE] flex flex-col">
              <div className="gap-[.5rem] flex items-center text-[#000] text-[1.125rem] font-[600] leading-[1.625rem]">
                <img src={item?.icon} alt={item?.icon} className="flex-shrink-0" /> {item?.label}
              </div>

              <div className="mt-[2.5rem] text-[#1E191B] text-[2.5rem] md:text-[2.875rem] font-[600] leading-[3.375rem]">
                {item?.value}
              </div>

              <div className="mt-[.75rem] text-[#7A7493] text-[.875rem] font-[400] leading-[1.5rem]">
                {item?.description}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default Numbers;
